export * from '@primeuix/themes/lara/checkbox';
export { default } from '@primeuix/themes/lara/checkbox';
